// extracted by mini-css-extract-plugin
module.exports = {"actions":"styles_actions__13-vA","col":"styles_col__2PFA_"};